type PendingSuffixState = unknown[];

export default (
  state: PendingSuffixState = [],
  action: { type: string; payload?: unknown },
): PendingSuffixState => {
  switch (action.type) {
    default:
      return state;
  }
};
